import { render, staticRenderFns } from "./take_out.vue?vue&type=template&id=5768c196&scoped=true"
import script from "./take_out.vue?vue&type=script&lang=js"
export * from "./take_out.vue?vue&type=script&lang=js"
import style0 from "./take_out.vue?vue&type=style&index=0&id=5768c196&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5768c196",
  null
  
)

export default component.exports